import { debounce } from 'es-toolkit/compat';
import $ from 'jquery';

var refreshForm = function refreshForm(e) {
  var $form = $(this).closest('form');
  var attributes = $form.data('refresh') || {};
  var $eventTarget = $(e.target);
  var $spinnerTarget = attributes.spinner_target ? $(attributes.spinner_target) : $form;
  var blurInput = $eventTarget.data('keep-active') !== true;
  var keepSpinner = attributes.keep_spinner == true;
  var url = attributes.path || $form.attr('action');

  if ($eventTarget.data('initial-value') === e.target.value) {
    return;
  }

  // check if the tab key (keycode 9) was used to get to an empty field
  if (e.type === 'keyup' && e.target.value === '' && e.which === 9) {
    return;
  }

  if (e.type === 'change' && e.target.type === 'text' && e.target.value !== '' && !$(e.target).hasClass('datepicker')) {
    return;
  }

  // masked inputs emit a change event when the value is formatted, causing a refresh loop
  if (e.isTrigger && $eventTarget.data('mask')) {
    return;
  }

  $spinnerTarget.showSpinner();
  if (blurInput) {
    $eventTarget.blur();
  }

  $form.data(
    'pendingRequest',
    $.ajax({
      url,
      method: attributes.method || 'GET',
      data: $form.serialize(),
      dataType: 'script',
      beforeSend() {
        if ($form.data('pendingRequest')) {
          $form.data('pendingRequest').abort();
        }
      },
    }).always(function refreshFormAlways(xhr, text_status) {
      var $refreshedInput = $(`#${e.target.id}`);
      if (blurInput && $refreshedInput.is('[type=text], textarea')) {
        var { length } = $refreshedInput.val();
        $refreshedInput.focus().get(0).setSelectionRange(length, length);
      }
      if (text_status != 'abort') {
        $form.removeData('pendingRequest');
        if (!keepSpinner) {
          $spinnerTarget.hideSpinner();
        }
      }

      // Only available in style-closet-legacy:
      if (typeof $.fn.addAriaAttributes === 'function') {
        $.fn.addAriaAttributes();
      }
    })
  );
};

$(document).on('change', '[data-behavior-refresh-form]', refreshForm);
$(document).on('formRefresh', '[data-behavior-refresh-form]', refreshForm);
$(document).on('keyup', '[data-behavior-refresh-form]', debounce(refreshForm, 1500));
